import PropTypes from "prop-types";
import React, { useContext, useEffect, useState } from "react";
import QuestionarioSeplag from "../../../../../components/QuestionarioSeplag";
import { AvaliacaoAcaoContext } from "./AvaliacaoAcaoContext";

const PercentageBlock = ({ width, className, percentage, label, isHighlighted, displayedPercentage }) => (
  <div style={{ width }}>
    <div className={className}>{percentage}</div>
    <div className="div-grafico-rodape">{label}</div>
    {isHighlighted && (
      <div>
        <i className="pi pi-arrow-up"></i>
        <label>
          {displayedPercentage.toLocaleString("pt-BR", {
            minimumFractionDigits: 3,
            maximumFractionDigits: 3,
          })}
        </label>
      </div>
    )}
  </div>
);

PercentageBlock.propTypes = {
  width: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  percentage: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  isHighlighted: PropTypes.bool.isRequired,
  displayedPercentage: PropTypes.number.isRequired,
};

const AnalisePPDCOFD = ({ porcentagemPrevistoInicial, podeAvaliarAcao }) => {
  const { setQuestAnaliseAtualizado, camposPPDCOFD, condicao, totalOrcamFinan, camposDispFinan, camposEficiencia } =
    useContext(AvaliacaoAcaoContext);
  // Estados para destacar as porcentagens (usando um único objeto para simplicidade)
  const [highlightedPercentage, setHighlightedPercentage] = useState({
    isPerc40PrevistoInicial: false,
    isPerc60PrevistoInicial: false,
    isPerc80PrevistoInicial: false,
    isPerc90PrevistoInicial: false,
    isPerc100PrevistoInicial: false,
    isPerc110PrevistoInicial: false,
    isPerc120PrevistoInicial: false,
    isPerc140PrevistoInicial: false,
    isPerc160PrevistoInicial: false,
    porcentagemPrevistoInicial: 0,
    isPerc60PrevistoAtualizado: false,
    isPerc80PrevistoAtualizado: false,
    isPerc90PrevistoAtualizado: false,
    isPerc100PrevistoAtualizado: false,
    isPerc110PrevistoAtualizado: false,
    isPerc120PrevistoAtualizado: false,
    isPerc140PrevistoAtualizado: false,
    isPerc160PrevistoAtualizado: false,
    porcentagemPrevistoAtualizado: 0,
  });

  const updateHighlightedPercentage = (key) => {
    setHighlightedPercentage((prevState) => ({
      ...prevState,
      [key]: true,
    }));
  };

  // Função para atualizar o estado de acordo com o valor de percPPD
  const reguaPPD = (percPPD) => {
    if (percPPD <= 40) {
      updateHighlightedPercentage("isPerc40PrevistoInicial");
    } else if (percPPD <= 60) {
      updateHighlightedPercentage("isPerc60PrevistoInicial");
    } else if (percPPD <= 80) {
      updateHighlightedPercentage("isPerc80PrevistoInicial");
    } else if (percPPD <= 90) {
      updateHighlightedPercentage("isPerc90PrevistoInicial");
    } else if (percPPD <= 100) {
      updateHighlightedPercentage("isPerc100PrevistoInicial");
    } else if (percPPD <= 110) {
      updateHighlightedPercentage("isPerc110PrevistoInicial");
    } else if (percPPD <= 120) {
      updateHighlightedPercentage("isPerc120PrevistoInicial");
    } else if (percPPD << 140) {
      updateHighlightedPercentage("isPerc140PrevistoInicial");
    }
  };

  // Função para atualizar o estado de acordo com o valor de percCOFD
  const reguaCOFD = (percCOFD) => {
    if (percCOFD <= 60) {
      updateHighlightedPercentage("isPerc60PrevistoAtualizado");
    } else if (percCOFD <= 80) {
      updateHighlightedPercentage("isPerc80PrevistoAtualizado");
    } else if (percCOFD <= 90) {
      updateHighlightedPercentage("isPerc90PrevistoAtualizado");
    } else if (percCOFD <= 100) {
      updateHighlightedPercentage("isPerc100PrevistoAtualizado");
    } else if (percCOFD <= 110) {
      updateHighlightedPercentage("isPerc110PrevistoAtualizado");
    } else if (percCOFD <= 120) {
      updateHighlightedPercentage("isPerc120PrevistoAtualizado");
    } else if (percCOFD <= 140) {
      updateHighlightedPercentage("isPerc140PrevistoAtualizado");
    } else if (percCOFD > 140) {
      updateHighlightedPercentage("isPerc160PrevistoAtualizado");
    }
  };

  useEffect(() => {
    setHighlightedPercentage((prevState) => ({
      ...prevState,
      porcentagemPrevistoInicial: totalOrcamFinan.vlrPpd,
      porcentagemPrevistoAtualizado: totalOrcamFinan.vlrCofd,
    }));
    reguaPPD(totalOrcamFinan.vlrPpd);
    reguaCOFD(totalOrcamFinan.vlrCofd);
  }, []);

  const renderizaPercentageBlock = (width, className, percentage, label, isHighlighted, displayedPercentage) => (
    <PercentageBlock
      width={width}
      className={className}
      percentage={percentage}
      label={label}
      isHighlighted={isHighlighted}
      displayedPercentage={displayedPercentage}
    />
  );

  return (
    <div className="content-panel">
      {/* Primeira seção do gráfico */}
      <div className="div-regua">
        <div className="div-titulo-grafico">
          <h3>PPD - Planejamento e Programação da Despesa</h3>
        </div>
        <div className="div-color">
          {/* {renderizaPercentageBlock("10%", "div-red", "40.000%", "Muito Deficiente", highlightedPercentage.isPerc40PrevistoInicial)} */}
          {renderizaPercentageBlock(
            "10%",
            "div-red",
            "60.000%",
            "Deficiente",
            highlightedPercentage.isPerc60PrevistoInicial,
            highlightedPercentage.porcentagemPrevistoInicial
          )}
          {renderizaPercentageBlock(
            "7.5%",
            "div-yellow",
            "80.000%",
            "Regular",
            highlightedPercentage.isPerc80PrevistoInicial,
            highlightedPercentage.porcentagemPrevistoInicial
          )}
          {renderizaPercentageBlock("6%", "div-green", "90.000%", "Bom", highlightedPercentage.isPerc90PrevistoInicial)}
          {renderizaPercentageBlock(
            "6%",
            "div-blue",
            "100.000%",
            "Ótimo",
            highlightedPercentage.isPerc100PrevistoInicial,
            highlightedPercentage.porcentagemPrevistoInicial
          )}
          {renderizaPercentageBlock(
            "7%",
            "div-green",
            "110.000%",
            "Bom",
            highlightedPercentage.isPerc110PrevistoInicial,
            highlightedPercentage.porcentagemPrevistoInicial
          )}
          {renderizaPercentageBlock(
            "8%",
            "div-yellow",
            "120.000%",
            "Regular",
            highlightedPercentage.isPerc120PrevistoInicial,
            highlightedPercentage.porcentagemPrevistoInicial
          )}
          {renderizaPercentageBlock(
            "8%",
            "div-red",
            "140.000%",
            "Deficiente",
            highlightedPercentage.isPerc140PrevistoInicial,
            highlightedPercentage.porcentagemPrevistoInicial
          )}
          {/* {renderizaPercentageBlock("8%", "div-red", "160.000%", "Muito Deficiente", highlightedPercentage.isPerc160PrevistoInicial)} */}
        </div>
      </div>
      {/* Segunda seção do gráfico (COFD) */}
      <div className="div-regua">
        <div className="div-titulo-grafico" style={{ marginTop: "40px" }}>
          <h3>COFD - Capacidade Operacional Financeira da Despesa</h3>
        </div>
        <div className="div-color" style={{ marginBottom: "20px" }}>
          {renderizaPercentageBlock(
            "10%",
            "div-red",
            "60.000%",
            "Deficiente",
            highlightedPercentage.isPerc60PrevistoAtualizado,
            highlightedPercentage.porcentagemPrevistoAtualizado
          )}
          {renderizaPercentageBlock(
            "7.5%",
            "div-yellow",
            "80.000%",
            "Regular",
            highlightedPercentage.isPerc80PrevistoAtualizado,
            highlightedPercentage.porcentagemPrevistoAtualizado
          )}
          {renderizaPercentageBlock(
            "6%",
            "div-green",
            "90.000%",
            "Bom",
            highlightedPercentage.isPerc90PrevistoAtualizado,
            highlightedPercentage.porcentagemPrevistoAtualizado
          )}
          {renderizaPercentageBlock(
            "6%",
            "div-blue",
            "100.000%",
            "Ótimo",
            highlightedPercentage.isPerc100PrevistoAtualizado,
            highlightedPercentage.porcentagemPrevistoAtualizado
          )}
          {renderizaPercentageBlock(
            "6%",
            "div-green",
            "110.000%",
            "Bom",
            highlightedPercentage.isPerc110PrevistoAtualizado,
            highlightedPercentage.porcentagemPrevistoAtualizado
          )}
          {renderizaPercentageBlock(
            "7.5%",
            "div-yellow",
            "120.000%",
            "Regular",
            highlightedPercentage.isPerc120PrevistoAtualizado,
            highlightedPercentage.porcentagemPrevistoAtualizado
          )}
          {renderizaPercentageBlock(
            "10%",
            "div-red",
            "140.000%",
            "Deficiente",
            highlightedPercentage.isPerc140PrevistoAtualizado,
            highlightedPercentage.porcentagemPrevistoAtualizado
          )}
        </div>
      </div>
      <QuestionarioSeplag
        campos={camposPPDCOFD}
        setCampos={setQuestAnaliseAtualizado}
        condicao={condicao}
        IsMaximoCaracteres={true}
        qtdMaxCaracteres={4000}
        isDisabled={!podeAvaliarAcao}
      />
    </div>
  );
};

// Definição de PropTypes para validação das props
AnalisePPDCOFD.propTypes = {
  porcentagemPrevistoInicial: PropTypes.number.isRequired,
  podeAvaliarAcao: PropTypes.bool.isRequired,
  condicao: PropTypes.string,
  camposPPDCOFD: PropTypes.array.isRequired,
  questionarioPPDCOFD: PropTypes.string.isRequired,
  questionarioDispFinan: PropTypes.string.isRequired,
  questionarioEficiencia: PropTypes.string.isRequired,
};

export default AnalisePPDCOFD;
